import { useHistory, useLocation } from 'react-router-dom';
import auth from '../../lib/auth';
import EnterEmail from './EnterEmail';

interface ILocationState {
  username?: string;
}

const LoginContainer = () => {
  const location = useLocation<ILocationState>();
  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);

  return (
    <EnterEmail
      confirmEmail={(em) => {
        searchParams.set('email', em);

        history.push({
          pathname: '/loginWithPassword',
          search: searchParams.toString(),
        });
      }}
      defaultEmail={searchParams.get('email') || location.state?.username || auth.getUserEmail() || ''}
      redirect={searchParams.get('redirect')}
    />
  );
};

export default LoginContainer;
